BookingApp.filter('BusFilter',function($filter){
    return function(input,Filter){
        var FilteredDate = [];
        //console.log(Filter);
        //Filtere By number of stops
        angular.forEach(input,function(value,key){
            //console.log(value);
            var ah = $filter('date')(value.DepartureTime,'HH');
            var aM = $filter('date')(value.DepartureTime,'m');
            ah = parseInt(ah);
            if(parseInt(aM)) ah += 1;
            if(
                    (!Filter.OperatorFilter.length || Filter.OperatorFilter.indexOf(value.TravelName) !== -1)
                &&  (!Filter.TypeFilter.length || Filter.TypeFilter.indexOf(value.BusType) !== -1)
                &&  (Filter.Price.mnp <= value.AvailableFares && Filter.Price.mxp >= value.AvailableFares)
                &&  (
                    (!Filter.IEMFT || (0 < ah && 8 >= ah))
                    &&  (!Filter.IMFT || (8 < ah && 12 >= ah))
                    &&  (!Filter.IMDFT || (12 < ah && 16 >= ah))
                    &&  (!Filter.INFT || (16 < ah && 24 >= ah))
                )
            ){
                FilteredDate.push(value);
            }
        });
        //console.log(FilteredDate);
        return FilteredDate;
    }
})
